import { Observable } from 'rxjs';
import { AccountingReportsRepository } from '../domain/accounting_reports/repository';
import { ReportDefinitionBase, ReportGenerateRequest } from '../domain/accounting_reports/model';
import HttpClient from '../utils/http-client';

export class AccountingReportsRepositoryImplementation extends AccountingReportsRepository {
  private httpClient: HttpClient;

  constructor(uid: string, cid: string | null) {
    super();
    this.httpClient = new HttpClient(uid, cid);
  }

  getAvailableReports(): Observable<ReportDefinitionBase[]> {
    return this.httpClient.get('/reports/reports');
  }

  generateReport(request: ReportGenerateRequest): Observable<any> {
    const { report_code, ...rest } = request;
    const params = new URLSearchParams();
    
    Object.entries(rest).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(v => params.append(key, v));
      } else if (value !== undefined && value !== null) {
        params.append(key, value as string);
      }
    });

    return this.httpClient.get(`/reports/reports/${report_code}?${params.toString()}`);
  }

  saveDailyClosure(data: any): Observable<any> {
    return this.httpClient.post('/reports/daily_closure/save', data);
  }
}
